import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { CARTS_BASE_PATH } from '@nike/cart-constants';
import { fetchClient, formatHeaders } from '@nike/fetch-client';
import { NIKE_API_HOST } from '@nike/ux-tread-dotcom-constants';

/**
 * Get Carts By Filter
 *
 * @param  {object} params - named parameters
 * @param {string} params.appId - appId provided by client app (unite uxid)
 * @param {string} params.token - user auth token (ux-tread-unite-redux getAuthToken)
 * @param {string} params.visitId - user visitId (ux-tread-unite-redux getVisitId)
 * @param {string} params.visitorId - user visitorId (ux-tread-unite-redux getVisitorId)
 * @param {string} params.brand - brand by default is Nike but can by for ex: Hurley
 * @param {string} params.channel - channel by default for web is NIKECOM
 * @param {string} params.country - country defaults to US (ux-tread-localization getCountry)
 * @param {string} [params.host=NIKE_API_HOST] - host value to be used in url fetching cart from, in case it needs to be modified for mocking* @param {string} [params.host=NIKE_API_HOST] - host value to be used in url fetching cart from, in case it needs to be modified for mocking
 * @param {object} params.fetchOptions - options to pass down to fetch
 * @returns {Promise} fetch promise
 */
export default function getCartsByParams(_ref) {
  var token = _ref.token,
    visitId = _ref.visitId,
    visitorId = _ref.visitorId,
    brand = _ref.brand,
    channel = _ref.channel,
    country = _ref.country,
    appId = _ref.appId,
    _ref$host = _ref.host,
    host = _ref$host === void 0 ? NIKE_API_HOST : _ref$host,
    fetchOptions = _ref.fetchOptions;
  return fetchClient("".concat(host, "/").concat(CARTS_BASE_PATH, "/").concat(country.toUpperCase(), "/").concat(brand, "/").concat(channel), _objectSpread({
    headers: formatHeaders({
      token: token,
      visitId: visitId,
      visitorId: visitorId,
      appId: appId
    }),
    method: 'GET',
    credentials: 'include'
  }, fetchOptions), 'Error retrieving data from carts by filters.', {
    pageActionName: 'tread-cart-event'
  });
}